/**
 * Quick View Functionality for Collection Pages
 * Opens a modal popup with product details when clicking "Quick View" on collection items
 */
(function() {
  'use strict';

  var modalId = 'quick-view-modal';
  var modal = null;
  var modalContent = null;
  var modalTitle = null;
  var isLoading = false;


  // Initialize when DOM is ready
  function initQuickView() {
    modal = document.getElementById(modalId);
    if (!modal) {
      console.warn('Quick View: Modal element not found');
      return;
    }

    modalContent = modal.querySelector('.QuickViewModal__Product');
    modalTitle = modal.querySelector('.QuickViewModal__Title');
    var loadingElement = modal.querySelector('.QuickViewModal__Loading');

    if (!modalContent) {
      console.warn('Quick View: Modal content element not found');
      return;
    }

    // Handle quick view button clicks using event delegation
    // Remove old listener if exists
    if (window._quickViewClickHandler) {
      document.removeEventListener('click', window._quickViewClickHandler);
    }

    window._quickViewClickHandler = function(event) {
      // Check if clicked element or parent has the data-action attribute for quick view
      var quickViewButton = event.target.closest('[data-action="open-modal"][aria-controls="' + modalId + '"]');
      
      if (!quickViewButton) {
        return;
      }

      // Prevent default and stop propagation
      event.preventDefault();
      event.stopPropagation();

      console.log('Quick View: Button clicked!', {
        button: quickViewButton,
        target: event.target,
        isLoading: isLoading
      });

      if (isLoading) {
        console.log('Quick View: Already loading');
        return;
      }

      var productHandle = quickViewButton.getAttribute('data-product-handle');
      var productUrl = quickViewButton.getAttribute('data-product-url');

      console.log('Quick View: Extracted data', { productHandle, productUrl });

      if (!productHandle) {
        console.error('Quick View: Missing product handle. Button attributes:', {
          handle: quickViewButton.getAttribute('data-product-handle'),
          url: quickViewButton.getAttribute('data-product-url'),
          action: quickViewButton.getAttribute('data-action')
        });
        return;
      }

      console.log('Quick View: Opening drawer for product:', productHandle);
      openQuickView(productHandle, productUrl);
    };

    // Use capture phase to catch the event early
    document.addEventListener('click', window._quickViewClickHandler, true);
    
    // Initialize close button handler
    initCloseButton();
    
    // Handle Escape key to close modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
        closeQuickView();
      }
    });
    
    console.log('Quick View: Event listener attached');

    console.log('Quick View: Initialized', {
      modal: !!modal,
      modalContent: !!modalContent,
      modalTitle: !!modalTitle
    });
  }
  
  // Handle close button clicks directly
  function initCloseButton() {
    if (!modal) return;
    
    var closeButton = modal.querySelector('[data-action="close-modal"]');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeQuickView();
      });
    }
  }

  function openQuickView(productHandle, productUrl) {
    console.log('Quick View: openQuickView called', { modal: !!modal, modalContent: !!modalContent, isLoading: isLoading });
    
    if (!modal) {
      console.error('Quick View: Modal element not found');
      return;
    }
    
    if (!modalContent) {
      console.error('Quick View: Modal content element not found');
      return;
    }
    
    if (isLoading) {
      console.log('Quick View: Already loading');
      return;
    }

    isLoading = true;
    var loadingElement = modal.querySelector('.QuickViewModal__Loading');
    
    // Show loading state
    if (loadingElement) {
      loadingElement.style.display = 'block';
    }
    modalContent.innerHTML = '';
    if (modalTitle) {
      modalTitle.textContent = '';
    }

    // Open modal immediately
    openModal();

    // Fetch product data via Shopify section rendering API
    // Try product URL first (product object should be available in that context)
    var productUrlToUse = productUrl || (window.routes.rootUrl + '/products/' + productHandle);
    var sectionUrl = productUrlToUse + '?section_id=quick-view-product';
    
    console.log('Quick View: Fetching from URL:', sectionUrl);
    
    fetch(sectionUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to load product');
      }
      return response.text();
    })
    .then(function(html) {
      console.log('Quick View: Received HTML response', html.substring(0, 500));
      
      // Parse the HTML response
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      
      // The response might be wrapped in a section or div, so search for the product content
      var productSection = doc.querySelector('.QuickViewProduct');
      
      // If not found, try to find it in a section wrapper
      if (!productSection) {
        var sectionWrapper = doc.querySelector('[data-section-type="quick-view-product"]') || 
                            doc.querySelector('#shopify-section-quick-view-product') ||
                            doc.querySelector('section');
        if (sectionWrapper) {
          productSection = sectionWrapper.querySelector('.QuickViewProduct');
        }
      }
      
      // If still not found, check the body or document directly
      if (!productSection) {
        productSection = doc.body.querySelector('.QuickViewProduct');
      }
      
      // If still not found, try to extract from any div that contains QuickViewProduct class
      if (!productSection) {
        var allDivs = doc.querySelectorAll('div');
        for (var i = 0; i < allDivs.length; i++) {
          if (allDivs[i].classList.contains('QuickViewProduct')) {
            productSection = allDivs[i];
            break;
          }
        }
      }
      
      // Last resort: check if the entire response is the product content
      if (!productSection) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        productSection = tempDiv.querySelector('.QuickViewProduct');
      }
      
      console.log('Quick View: Product section found', !!productSection);
      
      if (!productSection) {
        console.error('Quick View: Product data not found in response.');
        console.error('Response HTML:', html.substring(0, 1000));
        console.error('Document body:', doc.body ? doc.body.innerHTML.substring(0, 500) : 'No body');
        throw new Error('Product data not found in response');
      }

      // Hide modal header title - product title is already shown in product info
      if (modalTitle) {
        modalTitle.style.display = 'none';
      }

      // Hide loading and show content
      if (loadingElement) {
        loadingElement.style.display = 'none';
      }
      
      // Log the product section HTML before inserting
      console.log('Quick View: Product section HTML length:', productSection.outerHTML.length);
      console.log('Quick View: Product section contains form:', productSection.outerHTML.includes('ProductForm'));
      console.log('Quick View: Product section contains price:', productSection.outerHTML.includes('QuickViewProduct__Price'));
      
      // Insert the product content
      modalContent.innerHTML = productSection.outerHTML;
      
      // Debug: Check what was actually inserted
      console.log('Quick View: Content inserted, modalContent length:', modalContent.innerHTML.length);
      var insertedForm = modalContent.querySelector('.ProductForm');
      var insertedPrice = modalContent.querySelector('.QuickViewProduct__Price');
      var insertedVariants = modalContent.querySelector('.ProductForm__Variants');
      var insertedQuantity = modalContent.querySelector('.ProductForm__QuantitySelector');
      var insertedButton = modalContent.querySelector('.ProductForm__AddToCart');
      
      console.log('Form found:', !!insertedForm);
      if (insertedForm) {
        console.log('Form innerHTML length:', insertedForm.innerHTML.length);
        console.log('Form innerHTML preview:', insertedForm.innerHTML.substring(0, 200));
      }
      console.log('Price found:', !!insertedPrice);
      console.log('Variants found:', !!insertedVariants);
      console.log('Quantity selector found:', !!insertedQuantity);
      console.log('Add to cart button found:', !!insertedButton);
      
      // If form exists but is empty, log the form HTML
      if (insertedForm && insertedForm.innerHTML.trim().length < 50) {
        console.warn('Quick View: Form exists but appears empty:', insertedForm.innerHTML);
      }
      
      // If form doesn't exist, log the entire modal content
      if (!insertedForm) {
        console.error('Quick View: Form not found in inserted content!');
        console.error('Modal content preview:', modalContent.innerHTML.substring(0, 500));
      }

      // Initialize product form
      var productForm = modalContent.querySelector('.ProductForm');
      if (productForm) {
        // Check if AJAX cart (drawer) is enabled
        var useAjaxCart = true; // Default to true for drawer cart
        
        // Check cart type from cart drawer settings if available
        var cartDrawer = document.getElementById('sidebar-cart');
        if (cartDrawer) {
          var cartSettings = cartDrawer.getAttribute('data-section-settings');
          if (cartSettings) {
            try {
              var settings = JSON.parse(cartSettings);
              useAjaxCart = settings.drawer === true;
            } catch (e) {
              // Default to true
            }
          }
        }
        
        // IMPORTANT: Ensure form has correct action for ProductVariants
        // ProductVariants looks for form[action*="/cart/add"]
        if (!productForm.getAttribute('action') || !productForm.getAttribute('action').includes('/cart/add')) {
          productForm.setAttribute('action', window.routes.cartAddUrl);
        }
        
        // Initialize variant selector if ProductVariants is available
        var productVariants = null;
        if (typeof ProductVariants !== 'undefined') {
          try {
            console.log('Quick View: Initializing ProductVariants', {
              useAjaxCart: useAjaxCart,
              formAction: productForm.getAttribute('action'),
              hasAddToCartButton: !!productForm.querySelector('[data-action="add-to-cart"]')
            });
            productVariants = new ProductVariants(productForm, {
              useAjaxCart: useAjaxCart
            });
            console.log('Quick View: ProductVariants initialized successfully');
            
            // Verify button exists and ProductVariants can find it
            var addToCartButton = productForm.querySelector('[data-action="add-to-cart"]');
            console.log('Quick View: Checking add to cart button', {
              buttonFound: !!addToCartButton,
              button: addToCartButton,
              productVariantsInitialized: !!productVariants
            });
            
            if (!addToCartButton) {
              console.error('Quick View: Add to cart button not found! Searching in form...');
              var allButtons = productForm.querySelectorAll('button[type="submit"]');
              console.log('Quick View: Found submit buttons:', allButtons);
              allButtons.forEach(function(btn, idx) {
                console.log('Button ' + idx + ':', {
                  classes: btn.className,
                  dataAction: btn.getAttribute('data-action'),
                  innerHTML: btn.innerHTML.substring(0, 50)
                });
              });
            }
            
            // Listen for variant:changed event from ProductVariants (if it fires)
            productForm.addEventListener('variant:changed', function(e) {
              var newVariant = e.detail.variant;
              if (!newVariant) return;
              
              console.log('Quick View: variant:changed event received', newVariant);
              updateQuickViewPrice(productForm, newVariant);
            });

            // Listen for product added event at document level (CartSection also listens here)
            var productAddedHandler = function(e) {
              console.log('Quick View: Product added event received', e.detail);
              
              // Give CartSection time to handle opening the drawer
              // But also ensure it opens if CartSection doesn't handle it
              setTimeout(function() {
                var cartDrawer = document.getElementById('sidebar-cart');
                
                // Always try to open the drawer - CartSection should handle it, but ensure it opens
                if (cartDrawer) {
                  // Try multiple methods to open the drawer
                  var opened = false;
                  
                  // Method 1: Check if already open
                  if (cartDrawer.getAttribute('aria-hidden') === 'false') {
                    opened = true;
                    console.log('Quick View: Cart drawer already open');
                  } else {
                    // Method 2: Try clicking the open button
                    var openCartButton = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
                    if (openCartButton) {
                      openCartButton.click();
                      opened = true;
                      console.log('Quick View: Opened cart drawer via button click');
                    }
                  }
                  
                  // Method 3: Try to find and use drawer instance directly
                  if (!opened) {
                    var drawerSection = document.querySelector('[data-section-type="cart"]');
                    if (drawerSection && drawerSection.cartSection && drawerSection.cartSection.sidebarDrawer) {
                      drawerSection.cartSection.sidebarDrawer.open();
                      opened = true;
                      console.log('Quick View: Opened cart drawer via section instance');
                    }
                  }
                }
                
                // Close modal after a delay to let cart drawer open
                setTimeout(function() {
                  closeQuickView();
                  // Remove this listener since modal is closed
                  document.removeEventListener('product:added', productAddedHandler);
                }, 400);
              }, 300);
            };
            
            // Listen at document level (CartSection also listens here, so it will bubble up)
            document.addEventListener('product:added', productAddedHandler);
          } catch (e) {
            console.error('Quick View: ERROR initializing ProductVariants:', e);
            console.error('Quick View: Error stack:', e.stack);
            
            // If ProductVariants fails, we need to handle add to cart manually
            var addToCartBtn = productForm.querySelector('[data-action="add-to-cart"]');
            if (addToCartBtn && useAjaxCart) {
              console.warn('Quick View: ProductVariants failed, will need manual add to cart handling');
            }
          }
        } else {
          console.warn('Quick View: ProductVariants class is not available, implementing manual add-to-cart');
          
          // Implement manual add-to-cart since ProductVariants isn't available
          implementManualAddToCart(productForm, useAjaxCart);
        }

        // Handle select dropdown changes for variants - this is essential since ProductVariants
        // only listens to radio buttons, not select dropdowns
        var optionSelects = productForm.querySelectorAll('.ProductForm__OptionSelect');
        console.log('Quick View: Setting up select change listeners, found', optionSelects.length, 'selects');
        
        optionSelects.forEach(function(select) {
          select.addEventListener('change', function(e) {
            console.log('Quick View: Option select changed:', e.target.value);
            updateVariantFromSelects(productForm);
          });
        });

        // Handle quantity buttons - always set this up
        var quantityInput = productForm.querySelector('[name="quantity"]');
        var decreaseBtn = productForm.querySelector('[data-action="decrease-quantity"]');
        var increaseBtn = productForm.querySelector('[data-action="increase-quantity"]');
        
        if (decreaseBtn && quantityInput) {
          decreaseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = Math.max(1, currentValue - 1);
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
        
        if (increaseBtn && quantityInput) {
          increaseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
        
        // Form submission is already prevented above, so we don't need another handler here
        
        // Initialize thumbnail image switching
        initQuickViewThumbnails(modalContent);
      }

      isLoading = false;
    })
    .catch(function(error) {
      console.error('Quick View error:', error);
      
      if (loadingElement) {
        loadingElement.style.display = 'none';
      }
      
      modalContent.innerHTML = '<div class="QuickViewModal__Error"><p>' + 
        'Failed to load product. <a href="' + (productUrl || '#') + '">View product page</a>' +
        '</p></div>';
      
      isLoading = false;
    });
  }

  function openModal() {
    if (!modal) {
      console.error('Quick View: Modal not found');
      return;
    }

    // Use theme's Modal class if available
    if (typeof Modal !== 'undefined' && window.modalInstance) {
      window.modalInstance._openModal(modal);
    } else {
      // Fallback: manually open modal
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      
      // Show page overlay
      var pageOverlay = document.querySelector('.PageOverlay');
      if (pageOverlay) {
        pageOverlay.classList.add('is-visible');
      }
      
      // Focus management
      var focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length > 0) {
        setTimeout(function() {
          focusableElements[0].focus();
        }, 100);
      }
    }
  }

  function closeQuickView() {
    if (!modal) {
      return;
    }

    // Close modal by setting aria-hidden
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    
    // Hide page overlay
    var pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
    }
    
    // Clear content after animation
    setTimeout(function() {
      if (modalContent) {
        modalContent.innerHTML = '';
      }
      if (modalTitle) {
        modalTitle.textContent = '';
        modalTitle.style.display = '';
      }
    }, 300);
  }
  
  // Handle close button clicks directly
  function initCloseButton() {
    if (!modal) return;
    
    var closeButton = modal.querySelector('[data-action="close-modal"]');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeQuickView();
      });
    }
  }

  // Helper function to update variant from select dropdowns
  function updateVariantFromSelects(form) {
    console.log('Quick View: updateVariantFromSelects called');
    
    var optionSelects = form.querySelectorAll('.ProductForm__OptionSelect');
    var selectedOptions = {};
    
    optionSelects.forEach(function(select) {
      var position = select.getAttribute('data-option-position');
      if (position) {
        selectedOptions['option' + position] = select.value;
      }
    });
    
    console.log('Quick View: Selected options:', selectedOptions);

    // Find the matching variant
    var productJsonScript = form.querySelector('[data-product-json]');
    if (!productJsonScript) {
      console.error('Quick View: Product JSON not found');
      return;
    }
    
    try {
      var productData = JSON.parse(productJsonScript.innerHTML);
      var variants = productData.product.variants;
      
      console.log('Quick View: Total variants:', variants.length);
      
      // Find matching variant
      var matchedVariant = null;
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var match = true;
        
        if (selectedOptions['option1'] && variant.option1 !== selectedOptions['option1']) match = false;
        if (selectedOptions['option2'] && variant.option2 !== selectedOptions['option2']) match = false;
        if (selectedOptions['option3'] && variant.option3 !== selectedOptions['option3']) match = false;
        
        if (match) {
          matchedVariant = variant;
          break;
        }
      }
      
      console.log('Quick View: Matched variant:', matchedVariant ? matchedVariant.id : 'none', matchedVariant ? matchedVariant.price : '');

      if (matchedVariant) {
        // Update hidden variant ID input field
        var variantIdInput = form.querySelector('#quick-view-variant-id');
        if (!variantIdInput) {
          variantIdInput = form.querySelector('input[name="id"]');
        }
        if (variantIdInput) {
          variantIdInput.value = matchedVariant.id;
          console.log('Quick View: Updated variant ID to', matchedVariant.id);
        }
        
        // Also update hidden variant selector if it exists
        var hiddenSelect = form.querySelector('select[name="id"]');
        if (!hiddenSelect) {
          hiddenSelect = form.querySelector('#product-select-' + productData.product.id);
        }
        
        if (hiddenSelect) {
          hiddenSelect.value = matchedVariant.id;
          // Trigger change event
          var changeEvent = new Event('change', { bubbles: true });
          hiddenSelect.dispatchEvent(changeEvent);
        }
        
        // Update price display and button using helper function
        updateQuickViewPrice(form, matchedVariant);
      } else {
        console.warn('Quick View: No matching variant found for options:', selectedOptions);
      }
    } catch (e) {
      console.error('Quick View: Error updating variant:', e);
    }
  }
  
  // Helper function to format money - handles all Shopify money format variations
  function formatMoney(cents, format) {
    // Try using theme's Currency object first
    if (typeof Currency !== 'undefined' && Currency.formatMoney) {
      return Currency.formatMoney(cents, format);
    }
    
    // Fallback: handle Shopify money format strings manually
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      
      if (isNaN(number) || number == null) {
        return 0;
      }
      
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
      return dollarsAmount + centsAmount;
    }
    
    switch (format.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    
    return format.replace(placeholderRegex, value);
  }
  
  // Helper function to update Quick View price display
  function updateQuickViewPrice(form, variant) {
    if (!variant) return;
    
    var quickViewProduct = form.closest('.QuickViewProduct');
    if (!quickViewProduct) {
      console.error('Quick View: Could not find QuickViewProduct container');
      return;
    }
    
    var priceListElement = quickViewProduct.querySelector('.QuickViewProduct__PriceList');
    if (!priceListElement) {
      console.error('Quick View: Could not find price list element');
      return;
    }
    
    var currencyFormat = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '${{amount}}';
    var priceHtml = '';
    
    console.log('Quick View: Updating price display. Price:', variant.price, 'Compare at:', variant.compare_at_price);
    
    // Check if variant has a compare-at price (is on sale)
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHtml = '<span class="QuickViewProduct__Price Price Price--highlight Text--subdued u-h5" data-wg-notranslate="">' + 
                  formatMoney(variant.price, currencyFormat) + '</span>' +
                  '<span class="QuickViewProduct__Price Price Price--compareAt Text--subdued u-h6" data-wg-notranslate="">' + 
                  formatMoney(variant.compare_at_price, currencyFormat) + '</span>';
    } else {
      priceHtml = '<span class="QuickViewProduct__Price Price Text--subdued u-h5" data-wg-notranslate="">' + 
                  formatMoney(variant.price, currencyFormat) + '</span>';
    }
    
    priceListElement.innerHTML = priceHtml;
    console.log('Quick View: Price HTML updated');
    
    // Update Add to Cart button state based on availability
    var addToCartButton = form.querySelector('.ProductForm__AddToCart');
    if (addToCartButton) {
      if (variant.available) {
        addToCartButton.disabled = false;
        addToCartButton.setAttribute('data-action', 'add-to-cart');
        addToCartButton.innerHTML = '<span>' + ((window.languages && window.languages.productFormAddToCart) ? window.languages.productFormAddToCart : 'Add to cart') + '</span>';
      } else {
        addToCartButton.disabled = true;
        addToCartButton.removeAttribute('data-action');
        addToCartButton.innerHTML = (window.languages && window.languages.productFormSoldOut) ? window.languages.productFormSoldOut : 'Sold out';
      }
    }
  }

  // Manual add-to-cart implementation when ProductVariants isn't available
  function implementManualAddToCart(productForm, useAjaxCart) {
    console.log('Quick View: Setting up manual add-to-cart');
    
    var addToCartButton = productForm.querySelector('[data-action="add-to-cart"]');
    if (!addToCartButton) {
      addToCartButton = productForm.querySelector('button[type="submit"]');
    }
    
    if (addToCartButton) {
      console.log('Quick View: Setting up manual add-to-cart button handler');
      
      addToCartButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Quick View: Manual add-to-cart button clicked');
        
        // Update variant ID from selects if needed
        updateVariantFromSelects(productForm);
        
        // Get variant ID
        var variantIdInput = productForm.querySelector('input[name="id"]') || 
                            productForm.querySelector('#quick-view-variant-id') ||
                            productForm.querySelector('select[name="id"]');
        
        if (!variantIdInput || !variantIdInput.value) {
          console.error('Quick View: Could not find variant ID');
          alert('Please select a variant');
          return false;
        }
        
        var variantId = variantIdInput.value;
        var quantityInput = productForm.querySelector('[name="quantity"]');
        var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        // Disable button
        addToCartButton.disabled = true;
        var originalText = addToCartButton.innerHTML;
        addToCartButton.innerHTML = '<span>Adding...</span>';
        
        // Show loading
        if (typeof document.dispatchEvent !== 'undefined') {
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
        }
        
        console.log('Quick View: Adding to cart - variant:', variantId, 'quantity:', quantity);
        
        // Serialize form data (like ProductVariants does)
        var formData = {};
        var inputs = productForm.querySelectorAll('input[name], select[name]');
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if (input.name && !input.disabled) {
            if (input.type === 'checkbox' || input.type === 'radio') {
              if (input.checked) {
                formData[input.name] = input.value;
              }
            } else {
              formData[input.name] = input.value;
            }
          }
        }
        
        // Ensure id and quantity are set
        formData.id = variantId;
        if (quantityInput) {
          formData.quantity = quantity;
        }
        
        console.log('Quick View: Form data to send:', formData);
        
        // Add to cart via AJAX (using same format as ProductVariants)
        fetch(window.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify(formData)
        })
        .then(function(response) {
          if (typeof document.dispatchEvent !== 'undefined') {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          }
          
          if (!response.ok) {
            return response.json().then(function(data) {
              throw new Error(data.description || 'Failed to add to cart');
            });
          }
          
          return response.json();
        })
        .then(function(data) {
          console.log('Quick View: Successfully added to cart:', data);
          
          // Re-enable button
          addToCartButton.disabled = false;
          addToCartButton.innerHTML = originalText;
          
          // Get variant info for event
          var productJsonScript = productForm.querySelector('[data-product-json]');
          var variant = null;
          
          if (productJsonScript) {
            try {
              var productData = JSON.parse(productJsonScript.innerHTML);
              var variants = productData.product.variants;
              for (var i = 0; i < variants.length; i++) {
                if (variants[i].id == variantId) {
                  variant = variants[i];
                  break;
                }
              }
            } catch (e) {
              console.error('Quick View: Error parsing product JSON:', e);
            }
          }
          
          // Dispatch product:added event (like ProductVariants does)
          var productAddedEvent = new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant || { id: variantId },
              quantity: quantity
            }
          });
          
          productForm.dispatchEvent(productAddedEvent);
          document.dispatchEvent(productAddedEvent);
          
          // Refresh cart
          if (typeof document.dispatchEvent !== 'undefined') {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        })
        .catch(function(error) {
          console.error('Quick View: Error adding to cart:', error);
          
          if (typeof document.dispatchEvent !== 'undefined') {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          }
          
          addToCartButton.disabled = false;
          addToCartButton.innerHTML = originalText;
          
          alert('Error: ' + (error.message || 'Failed to add product to cart. Please try again.'));
        });
        
        return false;
      });
      
      // Listen for product added event to open cart drawer and close modal
      var productAddedHandler = function(e) {
        console.log('Quick View: Product added event received (manual)', e.detail);
        
        setTimeout(function() {
          var cartDrawer = document.getElementById('sidebar-cart');
          
          if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'true') {
            var openCartButton = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
            if (openCartButton) {
              openCartButton.click();
            }
          }
          
          setTimeout(function() {
            closeQuickView();
            document.removeEventListener('product:added', productAddedHandler);
          }, 400);
        }, 300);
      };
      
      document.addEventListener('product:added', productAddedHandler);
    } else {
      console.error('Quick View: Add to cart button not found for manual implementation');
    }
  }

  // Initialize thumbnail image switching for quick view
  function initQuickViewThumbnails(container) {
    var thumbnails = container.querySelectorAll('.QuickViewProduct__Thumbnail');
    var mainImage = container.querySelector('.QuickViewProduct__Image');
    var mainImageWrapper = container.querySelector('.QuickViewProduct__ImageWrapper');
    
    if (!thumbnails.length || !mainImage || !mainImageWrapper) {
      console.log('Quick View: No thumbnails or main image found');
      return;
    }
    
    console.log('Quick View: Initializing thumbnails', {
      thumbnailCount: thumbnails.length,
      hasMainImage: !!mainImage
    });
    
    thumbnails.forEach(function(thumbnail) {
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var mediaId = thumbnail.getAttribute('data-media-id');
        var mediaSrc = thumbnail.getAttribute('data-media-src');
        var mediaAlt = thumbnail.getAttribute('data-media-alt');
        
        if (!mediaSrc) {
          console.error('Quick View: No image source for thumbnail');
          return;
        }
        
        console.log('Quick View: Thumbnail clicked', {
          mediaId: mediaId,
          mediaSrc: mediaSrc
        });
        
        // Update main image
        mainImage.src = mediaSrc;
        mainImage.alt = mediaAlt;
        mainImage.setAttribute('data-media-id', mediaId);
        
        // Update active thumbnail
        thumbnails.forEach(function(thumb) {
          thumb.classList.remove('is-selected');
        });
        thumbnail.classList.add('is-selected');
      });
    });
  }

  // Initialize when everything is ready
  function init() {
    // Wait a bit for theme.js to load if needed
    var attempts = 0;
    var maxAttempts = 50; // 5 seconds max wait
    
    function tryInit() {
      attempts++;
      
      // Check if modal element exists in DOM
      var modalExists = document.getElementById(modalId);
      
      if (!modalExists) {
        if (attempts < maxAttempts) {
          setTimeout(tryInit, 100);
          return;
        } else {
          console.error('Quick View: Modal element never appeared in DOM');
          return;
        }
      }
      
      // Modal exists, now initialize
      initQuickView();
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(tryInit, 500); // Wait 500ms after DOM ready
      });
    } else {
      setTimeout(tryInit, 500);
    }
  }
  
  // Start initialization
  init();

  // Re-initialize after AJAX content loads (for infinite scroll, etc.)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initQuickView, 100);
  });
})();

/**
 * Load More Products - AJAX Pagination for Collection Pages
 * Instead of traditional pagination, this fetches and appends products dynamically
 * when clicking the "Load More" button
 */
(function() {
  'use strict';

  var loadMoreBtn = null;        // The "Load More" button element
  var productGrid = null;        // Container for product cards
  var progressElement = null;    // Shows "Showing X of Y products"
  var productsShownElement = null; // Span inside progress showing current count
  var isLoading = false;         // Prevents multiple simultaneous requests

  /**
   * Initialize the Load More functionality
   * Finds DOM elements and attaches click handler
   */
  function initLoadMore() {
    loadMoreBtn = document.getElementById('load-more-btn');
    productGrid = document.getElementById('collection-product-grid');
    progressElement = document.getElementById('load-more-progress');
    productsShownElement = document.getElementById('products-shown');

    // Exit if elements don't exist (maybe pagination is used instead)
    if (!loadMoreBtn || !productGrid) {
      return;
    }

    // Attach click handler to Load More button
    loadMoreBtn.addEventListener('click', handleLoadMore);
    
    console.log('Load More: Initialized', {
      totalPages: productGrid.dataset.totalPages,
      currentPage: productGrid.dataset.currentPage
    });
  }

  /**
   * Handle Load More button click
   * Uses Shopify's Section Rendering API for optimal performance
   * Only fetches the collection section (~20KB) instead of full page (~100KB+)
   */
  function handleLoadMore(e) {
    e.preventDefault();
    
    if (isLoading) return; // Don't allow multiple requests
    
    var nextPage = parseInt(loadMoreBtn.dataset.nextPage, 10);
    var totalPages = parseInt(productGrid.dataset.totalPages, 10);
    
    // Don't load if we've reached the last page
    if (nextPage > totalPages) {
      hideLoadMoreButton();
      return;
    }
    
    // Show loading state
    setLoadingState(true);
    
    // Get the section ID from the parent collection section
    var collectionSection = productGrid.closest('[data-section-id]');
    var sectionId = collectionSection ? collectionSection.dataset.sectionId : 'main-collection';
    
    // Build optimized URL using Section Rendering API
    // This fetches ONLY the collection section HTML, not the entire page
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', nextPage);
    currentUrl.searchParams.set('section_id', sectionId); // KEY: Section Rendering API
    
    console.log('Load More: Fetching page', nextPage, '(section only)', currentUrl.toString());
    
    // Fetch only the collection section HTML (much smaller payload)
    fetch(currentUrl.toString())
      .then(function(response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function(html) {
        // Parse the section HTML response
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        
        // Find the product grid in the fetched section
        var newGrid = doc.getElementById('collection-product-grid');
        
        if (newGrid) {
          // Get all product cards from the new page
          var newProducts = newGrid.querySelectorAll('.Grid__Cell');
          
          console.log('Load More: Found', newProducts.length, 'new products');
          
          // Use DocumentFragment for better performance when adding multiple elements
          var fragment = document.createDocumentFragment();
          
          // Prepare products for animation
          newProducts.forEach(function(product) {
            product.style.opacity = '0';
            product.style.transform = 'translateY(20px)';
            fragment.appendChild(product);
          });
          
          // Single DOM update - more efficient than multiple appendChild calls
          productGrid.appendChild(fragment);
          
          // Trigger reflow, then animate all products with staggered timing
          requestAnimationFrame(function() {
            var addedProducts = productGrid.querySelectorAll('.Grid__Cell[style*="opacity: 0"]');
            addedProducts.forEach(function(product, index) {
              setTimeout(function() {
                product.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
                product.style.opacity = '1';
                product.style.transform = 'translateY(0)';
              }, index * 50);
            });
          });
          
          // Update the page counter
          productGrid.dataset.currentPage = nextPage;
          loadMoreBtn.dataset.nextPage = nextPage + 1;
          
          // Update progress text (Showing X of Y)
          updateProgressText();
          
          // Hide button if we've loaded all pages
          if (nextPage >= totalPages) {
            hideLoadMoreButton();
          }
          
          // Re-trigger lazy loading for new images (if lazysizes is used)
          if (window.lazySizes) {
            lazySizes.autoSizer.checkElems();
          }
          
          // Dispatch event for other scripts to hook into (e.g., quick view)
          document.dispatchEvent(new CustomEvent('loadmore:loaded', {
            detail: { page: nextPage, products: newProducts.length }
          }));
        }
        
        setLoadingState(false);
      })
      .catch(function(error) {
        console.error('Load More: Error fetching products', error);
        setLoadingState(false);
        // Show error message to user
        loadMoreBtn.querySelector('.LoadMore__Text').textContent = 'Error - Click to retry';
      });
  }

  /**
   * Toggle loading state on the button
   * Shows spinner and disables button while loading
   */
  function setLoadingState(loading) {
    isLoading = loading;
    
    var textElement = loadMoreBtn.querySelector('.LoadMore__Text');
    var loadingElement = loadMoreBtn.querySelector('.LoadMore__Loading');
    
    if (loading) {
      loadMoreBtn.disabled = true;
      loadMoreBtn.classList.add('is-loading');
      textElement.style.display = 'none';
      loadingElement.style.display = 'inline-flex';
    } else {
      loadMoreBtn.disabled = false;
      loadMoreBtn.classList.remove('is-loading');
      textElement.style.display = 'inline';
      loadingElement.style.display = 'none';
    }
  }

  /**
   * Update the "Showing X of Y products" text
   */
  function updateProgressText() {
    if (!productsShownElement) return;
    
    var currentProducts = productGrid.querySelectorAll('.Grid__Cell').length;
    productsShownElement.textContent = currentProducts;
  }

  /**
   * Hide the Load More button when all products are loaded
   * Shows a "All products loaded" message instead
   */
  function hideLoadMoreButton() {
    loadMoreBtn.style.display = 'none';
    
    if (progressElement) {
      progressElement.innerHTML = '<span class="LoadMore__Complete">✓ All products loaded</span>';
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }

  // Re-initialize after Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initLoadMore, 100);
  });
})();
